module.exports = __webpack_public_path__ + "img/presenter_watanabe.56bb4ec4.jpg";